var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-8" },
      [
        _c("q-input", {
          staticClass: "no-shadow",
          attrs: {
            type: "number",
            name: "qbInvoiceId",
            "hide-underline": "",
            "inverted-light": "",
            color: _vm.inputBgColor
          },
          on: { input: _vm.updateParent },
          model: {
            value: _vm.qbInvoiceId,
            callback: function($$v) {
              _vm.qbInvoiceId = $$v
            },
            expression: "qbInvoiceId"
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-4" },
      [
        _c("q-btn", {
          staticClass: "full-width",
          attrs: {
            label: "View/Edit Invoice",
            icon: "receipt",
            color: "secondary",
            disable: !_vm.qbInvoiceId
          },
          on: {
            click: function($event) {
              return _vm.externalLink("invoice?txnId=" + _vm.qbInvoiceId)
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }